import React from 'react';
import { Button, CardHeader } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Role, useAuthentication } from '../../contexts/Authentication';

const canSeeRevision = (roles: Role[]) => {
  return roles.some(e => [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior].includes(e))
}

interface ArticleHeaderProps {
  type: string,
  slug: string,
}

const ArticleHeader = (props: ArticleHeaderProps) => {
  const history = useHistory();
  const path = history.location.pathname.split("/");
  const auth = useAuthentication()

  return <>
    <CardHeader action={
      <>
        <Button color="primary" variant={path[path.length - 1] === "edit" ? "contained" : "text"} onClick={() => {
          history.push(`/articles/edit/${props.type}/${props.slug}/edit`);
        }}>Edit</Button>
        {
          canSeeRevision(auth.role) &&
          <Button color="primary" variant={path[path.length - 1] === "revision" ? "contained" : "text"} onClick={() => {
            history.push(`/articles/edit/${props.type}/${props.slug}/revision`);
          }}>Revision</Button>
        }
      </>
    } />

  </>
}

export default ArticleHeader;